import React, { useState } from 'react';
import MaskedInput from 'react-text-mask';
import api from '../../services/api';
import * as S from './CadastroUsuarioModal.styles';

function CadastroUsuarioModal({ onClose }) {
    const [nome, setNome] = useState('');
    const [cpf, setCpf] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [erro, setErro] = useState('');
    const [enviando, setEnviando] = useState(false);
    const [cadastroEnviado, setCadastroEnviado] = useState(false);

    async function enviarCadastro(event) {
        event.preventDefault();
        setErro('');

        if (senha !== confirmarSenha) {
            setErro('As senhas não conferem.');
            return;
        }

        setEnviando(true);
        try {
            await api.post('/usuario/cadastro', {
                nome: nome.trim(),
                cpf: cpf.replace(/\D/g, ''),
                email: email.trim().toLowerCase(),
                senha,
            });
            setCadastroEnviado(true);
        } catch (error) {
            setErro(error.response?.data?.message || 'Não foi possível enviar seu cadastro. Tente novamente.');
        } finally {
            setEnviando(false);
        }
    }

    return (
        <S.Overlay onMouseDown={event => {
            if (event.target === event.currentTarget) {
                onClose();
            }
        }}>
            <S.Card role="dialog" aria-modal="true" aria-labelledby="signup-title">
                <S.CloseButton type="button" aria-label="Fechar cadastro" onClick={onClose}>
                    ×
                </S.CloseButton>

                {cadastroEnviado ? (
                    <S.Success>
                        <S.Icon aria-hidden="true">✓</S.Icon>
                        <h2 id="signup-title">Cadastro recebido</h2>
                        <p>
                            Seu acesso ficará disponível após a aprovação do usuário master.
                            Você poderá entrar com seu e-mail e senha depois da aprovação.
                        </p>
                        <S.SubmitButton type="button" onClick={onClose}>
                            Voltar ao login
                        </S.SubmitButton>
                    </S.Success>
                ) : (
                    <>
                        <S.Eyebrow>Novo acesso</S.Eyebrow>
                        <h2 id="signup-title">Cadastre-se</h2>
                        <S.Description>
                            Preencha seus dados. Seu cadastro será revisado antes da liberação do acesso.
                        </S.Description>

                        <form onSubmit={enviarCadastro}>
                            <S.Fields>
                                <label>
                                    Nome completo
                                    <input
                                        autoFocus
                                        autoComplete="name"
                                        maxLength={120}
                                        required
                                        value={nome}
                                        onChange={event => setNome(event.target.value)}
                                    />
                                </label>

                                <label>
                                    CPF
                                    <MaskedInput
                                        autoComplete="off"
                                        mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                                        required
                                        value={cpf}
                                        onChange={event => setCpf(event.target.value)}
                                        guide={false}
                                        placeholder="000.000.000-00"
                                    />
                                </label>

                                <label>
                                    E-mail
                                    <input
                                        autoComplete="email"
                                        maxLength={160}
                                        required
                                        type="email"
                                        value={email}
                                        onChange={event => setEmail(event.target.value)}
                                    />
                                </label>

                                <S.PasswordFields>
                                    <label>
                                        Senha
                                        <input
                                            autoComplete="new-password"
                                            minLength={8}
                                            required
                                            type="password"
                                            value={senha}
                                            onChange={event => setSenha(event.target.value)}
                                        />
                                    </label>
                                    <label>
                                        Confirmar senha
                                        <input
                                            autoComplete="new-password"
                                            minLength={8}
                                            required
                                            type="password"
                                            value={confirmarSenha}
                                            onChange={event => setConfirmarSenha(event.target.value)}
                                        />
                                    </label>
                                </S.PasswordFields>
                            </S.Fields>

                            {erro && <S.Error role="alert">{erro}</S.Error>}
                            <S.SubmitButton type="submit" disabled={enviando}>
                                {enviando ? 'Enviando...' : 'Solicitar cadastro'}
                            </S.SubmitButton>
                        </form>
                    </>
                )}
            </S.Card>
        </S.Overlay>
    );
}

export default CadastroUsuarioModal;
